import { createSelector } from 'reselect';

import { residenceHistorySelector } from '../../../reducers/selectors';

const requiresExtraAddressesSelector = createSelector(
  residenceHistorySelector,
  (residenceHistory = []) => {
    const addressesNeeded = residenceHistory.filter(res => res.addressRequired === true).length;
    const addressLabels = {
      1: 'oneAddressNeeded',
      2: 'twoAddressesNeeded',
      3: 'threeAddressesNeeded',
    };

    return addressLabels[addressesNeeded];
  },
);

export default requiresExtraAddressesSelector;
